
import React from 'react';
import DynamicAsset from 'components/DynamicAsset';
import Illustration from 'templates/reports/Section/Illustration';

const vat = 'https://static.bodyspec.com/at/e7/bd/e7bdc99a37cd7d22';

export const VisceralFat = () => {
	return (
		<Illustration>
			<DynamicAsset imageSrc={vat} />
		</Illustration>
	);
};
